// extracted by mini-css-extract-plugin
module.exports = {"title":"TitlePage-module--title--T_FdX"};